export default {
  devTitle: 'EMMA LEE',
  index: 'Index',
  info: 'Info',

  // Main
  copyRight: 'Copyright',

  // 置底用
  aaa: 'aaa'
}
